// extracted by mini-css-extract-plugin
module.exports = {"sideBlock":"BTkj","header":"BTap","list":"BTar","item":"BTat","link":"BTch"};